import { useEffect, useState } from "react";
import { GLItemStatus, GLItemKind } from "../../../DTO/GLItemDTO";
import { GLItemsDTO } from "../../../DTO/GLItemsDTO";

export default function LogChatAmountDisplay ({
    status,
    kind,
}: {
    status?: GLItemStatus,
    kind?: GLItemKind,
}) {
    const [glitems] = useState(new GLItemsDTO({
        page: 1,
        limit: 1,
        kind,
        status,
    }))
    const [total, setTotal] = useState(0)
    useEffect(() => {
        let intervalId: NodeJS.Timeout;
        setTimeout(() => {
            glitems.getFromServer().then(() => {
                setTotal(glitems.total)
            })
            intervalId = setInterval(() => {
                glitems.getFromServer().then(() => {
                    setTotal(glitems.total)
                })
            }, 30000)
        }, Math.random() * 6000)
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [])

    if (total > 0) {
        return <span> ({total})</span>
    }
    return null
}
